import React, { Component } from 'react';
import { Modal, Spin, message, Radio, InputNumber } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import SearchRetrieve from '../../common/SearchRetrieve.new';


class UpdateAssignWeight extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
    }

    show = () => {
        this.setState({
            data: [],
            visible: true,
        }, () => {
            this.getDate();
        });
    }

    getDate = () => {
        const options = {
            method: "POST",
            url: API_URL.home.queryEffectiveDate,
            data: {},
            dataType: "json",
            doneResult: (res) => {
                const { date } = res;
                const yearNum = moment(date).format("YYYY");
                const monthNum = moment(date).format("MM");
                this.setState({
                    yearNum,
                    monthNum
                },() => {
                    const { invState, siteId } = sessionStorage;
                    if (invState == 2) {
                        this.loadData(siteId);
                    }
                })
            },
        };
        $.sendRequest(options);
    };

    loadData = (siteId) => {
        const { yearNum, monthNum } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.queryMainCrcList,
            data: {
                yearNum,
                monthNum,
                investigationSiteId: siteId,
            },
            dataType: 'json',
            doneResult: res => {
                const { list } = res;
                let assignWeight;
                list.forEach(i => i.assignWeight *= 100);
                assignWeight = 100;
                list.unshift({
                    userId: 'head',
                    userCompellation: 'CRC',
                    mainCrc: '主要CRC',
                    assignWeight: '访视数分配系数',
                });
                list.push({
                    userId: 'foot',
                    userCompellation: '合计',
                    assignWeight,
                });
                this.setState({
                    data: list,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { data, yearNum, monthNum, investigationSiteId } = this.state;
        const { invState, siteId } = sessionStorage;
        let idx = 0;
        const params = {};
        for (let i = 1, len = data.length; i < len; i++) {
            const { userId, userCompellation, mainCrc, assignWeight } = data[i];
            if (i < (len - 1)) {
                if (!assignWeight && assignWeight !== 0) {
                    message.warning(`请分配CRC${userCompellation}的访视数系数！`);
                    return;
                }
                params[`siteCrcViewList[${idx}].userId`] = userId;
                params[`siteCrcViewList[${idx}].mainCrc`] = mainCrc;
                params[`siteCrcViewList[${idx}].assignWeight`] = assignWeight;
                idx++;
            } else {
                const parseAssignWeight = assignWeight.toFixed(2);
                if (parseAssignWeight != 100) {
                    message.warning(`请确保各CRC的访视数分配系数之和为100%！`);
                    return;
                }
            }
        }
        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.saveSiteMainCrc,
            data: {
                yearNum,
                monthNum,
                investigationSiteId: invState == 2 ? siteId : investigationSiteId,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getNumber = (value) => {
        var number = parseFloat(value);
        return (number && ((number !== number || 0 ) || number)) || 0;
    }

    handleRadioChange = (e, idx) => {
        const { data } = this.state;
        data.forEach((item, index) => {
            if (index > 0) {
                if (idx === index) {
                    item.mainCrc = 1;
                } else {
                    item.mainCrc = 0;
                }
            }
        });
        this.setState({ data });
    }

    handleNumberChange = (value, index) => {
        const { data } = this.state;
        data[index].assignWeight = value;
        let total = 0;
        const lastIndex = data.length - 1;
        data.forEach((item, index) => {
            if (index !== 0 && index !== lastIndex) {
                total += this.getNumber(item.assignWeight);
            }
        });
        data[lastIndex].assignWeight = total;
        this.setState({ data });
    }

    getContent = () => {
        const { data } = this.state;
        const result = [];
        data.forEach((item, index) => {
            const { userId, userCompellation, employeeCode, assignWeight, hourStatus } = item;
            if (index === 0) {
                result.push(
                    <li key={userId} className="flexRow head">
                        <div className="flexItem">{userCompellation}</div>
                        <div className="flexItem">{assignWeight}</div>
                    </li>
                );
            } else if (index === (data.length - 1)) {
                result.push(
                    <li key={userId} className="flexRow foot borderTop">
                        <div className="flexItem">{userCompellation}</div>
                        <div className="flexItem">{assignWeight.toFixed(2)}<span style={{ marginLeft: 10 }}>%</span></div>
                    </li>
                );
            } else {
                result.push(
                    <li key={userId} className="flexRow">
                        <div className="flexItem">{`${userCompellation}[${employeeCode}]`}</div>
                    
                        <div className="flexItem">
                            {
                                hourStatus === 'VERIFY' ?
                                    assignWeight.toFixed(2)
                                :
                                    <InputNumber
                                        min={0}
                                        max={100}
                                        precision={2}
                                        value={assignWeight}
                                        style={{ width: 70, marginRight: 10 }}
                                        onChange={value => this.handleNumberChange(value, index)}
                                    />
                            }
                            %
                        </div>
                    </li>
                );
            }
        });
        return result;
    }

    handleSearchRetrieveChange = (options) => { 
        const { value, text } = options;
        this.setState({
            investigationSiteId: value,
            investigationSiteName: text,
        },() => {
            if (value) {
                this.loadData(value);
            }
        })
    }

    render() {
        const { visible, loading, yearNum, monthNum, investigationSiteName } = this.state;
        const { invState, invId, investigationSiteName: siteName, investigationSiteCode } = sessionStorage;
        return (
            <Modal
                title={'修改访视数分配系数'}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
            >
                <Spin spinning={loading}>
                    <div style={{ padding: 20 }}>
                        <div style={{ display: 'flex', alignItems: 'center', width: 300, margin: 12 }}>
                            <div style={{ width: '30%', textAlign: 'right' }}>中心：</div>
                            <div style={{ width: '70%' }}>
                                {
                                    invState == 1 ?
                                    <SearchRetrieve
                                        keyword='keyword'
                                        style={{ width: 160 }}
                                        placeholder='键入中心名称自动检索'
                                        params={{ invId }}
                                        url={API_URL.manhour.queryInvestigation}
                                        config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'site', show: 'site' }}
                                        value={investigationSiteName}
                                        onChange={options => this.handleSearchRetrieveChange(options, 'investigationSite')}
                                    />
                                    :  `${siteName}（${investigationSiteCode}）`
                                }
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', width: 300, margin: 12 }}>
                            <div style={{ width: '30%', textAlign: 'right' }}>工作日期：</div>
                            <div style={{ width: '70%' }}>{yearNum}-{monthNum}</div>
                        </div>
                        <ul className="flexTable">
                            {this.getContent()}
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default UpdateAssignWeight


// WEBPACK FOOTER //
// ./src/components/execute/manHour/UpdateAssignWeight.js